import React, { useState } from 'react';
import './blog-post.css';
import './blog-slides.css';

import officer from './pictures/officer.png';

const Cherry = () => {
  return (
    <div>
      <div className='blog__container'>
        <div class="row">
            <div class="column">
                <header></header>

                <section>
                    <h2>WiC LinkedIn Headshots Event!</h2>
                    <p class="site-post-meta">April 4, 2025</p>
                    <hr></hr>
                </section>
                <section>
                    <p>
                    Hi WiC members! 
                    <br></br>
                    <br></br>

                    🌸 On April 4th, WiC hosted a LinkedIn headshots session on the quad! Members got to pose for their headshots under the beautiful cherry blossoms! 🌸
                    </p>
                    <img src={officer} alt="pic1 "/>
                </section>
            </div>
        </div>      
      </div>
    </div>
  );
};

export default Cherry;
